// ~~~~~~~~~~~ Logging
const debugInfoElem = /**@type HTMLElement*/(document.getElementById("debugInfo"));

export function log(/**@type any */msg) {
    console.log(msg);
    displayDebugMessage(msg);
};

export function logError(/**@type any */msg) {
    console.error(msg);
    displayDebugMessage("ERROR: " + msg)
};

/**
 * @param {String} message
 */
function displayDebugMessage(message) {
    const time = new Date().toLocaleTimeString();
    const msgElem = document.createElement("p");
    msgElem.append(`(${time}) `, message);
    appendToDebugInfo(msgElem);
}

/**
 * @param {HTMLElement} element
 */
export function appendToDebugInfo(element) {
    debugInfoElem.appendChild(element);
    debugInfoElem.scrollTop = debugInfoElem.scrollHeight;
}


// ~~~~~~~~~~~ Session

export const getUserId = () => { return sessionStorage.getItem("userId"); };
export const setUserId = (/**@type string*/ userId) => {
    sessionStorage.setItem("userId", userId);
};

export const getRoomId = () => {
    return new URLSearchParams(window.location.search).get("roomId");
};

/**
 * Updates the `roomId` query parameter. If `null` (or any other 'falsy' value,
 * e.g. an empty string) is given the roomId parameter is deleted.
 * @param {string|null} roomId The new room ID.
 */
export const setRoomId = (/**@type string*/ roomId) => {
    const url = new URL(location.href);
    if (roomId) {
        url.searchParams.set("roomId", roomId);
    } else {
        url.searchParams.delete(roomId);
    }

    if (url.href !== location.href) {
        history.pushState({}, "", url);
    }
};

// ~~~~~~~~~~~ Other

export class SimpleTableBuilder {
    constructor() {
        this.table = document.createElement("table");
    }

    /** @param {any[]} cellsText */
    addRow(...cellsText) {
        const tr = document.createElement("tr");
        cellsText.forEach((cellText) => {
            const td = document.createElement("td");
            td.innerText = cellText;
            tr.appendChild(td);
        });
        this.table.appendChild(tr);
    }

    /** @returns {HTMLTableElement} */
    build() {
        return this.table;
    }
}

/**
 * Creates a clickable link element pointing to the `target` and displayed as
 * the given `labelText`.
 * @param {String} target Value passed to the href attribute, e.g. a URL.
 * @param {String=} labelText Text visible to the user. Defaults to the value 
 *      of `target` if a falsy value is provided.
 * @returns {HTMLAnchorElement} 
 */
export function createLinkElem(target, labelText) {
    const link = document.createElement("a");
    link.href = target;
    link.innerText = labelText ? labelText : target;
    return link;
}
